<!-- @format -->
<template>
	<van-form @submit="onSubmit">
		<div class="title">发票详情</div>
		<div class="white-card">
			<van-field name="radio" label="发票类型">
				<template #input>
					<van-radio-group
						v-model="form.headingType"
						direction="horizontal"
						checked-color="#15C5CE"
						@change="changeHandle"
					>
						<van-radio :name="1">个人</van-radio>
						<van-radio :name="2">企业</van-radio>
					</van-radio-group>
				</template>
			</van-field>
			<van-field
				v-model="form.headingName"
				label="抬头名称"
				placeholder="请输入抬头名称"
				maxlength="”200"
				:rules="[{ required: true }]"
			/>
			<div v-if="form.headingType==2">
				<van-field
					v-model="form.taxNumber"
					label="企业税号"
					placeholder="请输入企业税号"
					maxlength="200"
					:rules="[{ required: true}]"
				/>
				<van-field v-model="form.registerAddress" label="企业地址" placeholder="选填" maxlength="400" />
				<van-field v-model="form.registerPhone" label="企业电话" placeholder="选填" maxlength="20" />
				<van-field v-model="form.depositBank" label="开户银行" placeholder="选填" maxlength="400" />
				<van-field
					v-model="form.bankAccount"
					label="银行账号"
					placeholder="选填"
					type="number"
					maxlength="25"
				/>
			</div>
		</div>

		<foot-button>
			<van-button :disabled="disabled" block type="primary" native-type="submit">提交</van-button>
		</foot-button>
	</van-form>
</template>

<script>

	export default {
	    name:'Invoicing',
	    data () {
	        return {
	            form:{
	                headingType:1,
	                headingName:'',
	                taxNumber:'',
	                registerAddress:'',
	                registerPhone:'',
	                depositBank:'',
	                bankAccount:'',
				},
				disabled:true
	        }
		},
		watch:{
			'form.headingName'(val){
				if(this.form.headingType==1&&val){
					this.disabled = false
				}
				if(this.form.headingType==2&&this.form.taxNumber&&val){
					this.disabled = false
				}
			},
			'form.taxNumber'(val){
				if(this.form.headingType==2&&this.form.headingName&&val){
					this.disabled = false
				}
			},

		},

		created() {

		},

		methods: {
			changeHandle(){
				this.form.headingName = ''
				this.form.taxNumber = ''
				this.form.registerAddress = ''
				this.form.registerPhone = ''
				this.form.depositBank = ''
				this.form.bankAccount = ''
				this.disabled = true
			},
			onSubmit(){
					let params = {
						...this.form,
						orderId:this.$route.params.id
					}
					this.$api.order.issueInvoice(params).then(res=>{
						if(!res.code){
							this.$router.push(`/order/invoicing-success/${this.$route.params.id}`)
						}
					})
			}
		}
	}
</script>

<style lang="less" scoped>
	.title {
		font-size: 28px;
		color: #8F959E;
		margin: 32px 32px 0;
	}
	.white-card {
		background-color: #fff;
		padding: 0 20px;
		border-radius: 16px;
		margin: 32px;
		.van-cell {
			height: 100px;
			line-height: 100px;
			font-size: 30px;
			border-bottom: 1px solid #f1f1f1;
			align-items: center;
			&:last-child {
				border: none;
			}
			&::after {
				display: none;
			}
			/deep/.van-field__label {
				color: #1F2329;
			}
		}
	}
</style>
